/**
 * OIDC Configuration for Duende IdentityServer
 *
 * This is the web/default config. The native app overrides `oidcConfig` via
 * `config.native.ts` so token refresh/revocation use the platform-specific
 * client id that login was performed with.
 */

import {
    OIDC_ISSUER,
    OIDC_CLIENT_ID,
    OIDC_REDIRECT_URI,
    OIDC_POST_LOGOUT_REDIRECT_URI,
} from 'common/env';

import { OidcConfig, OIDC_SCOPES } from './shared';

export { getOidcEndpoints } from './shared';
export type { OidcConfig } from './shared';

const getRequiredValue = (name: string, value: string) => {
    if (!value) {
        throw new Error(`Missing required OIDC configuration: ${name}`);
    }

    return value;
};

export const oidcConfig: OidcConfig = {
    get issuer() {
        return getRequiredValue('OIDC_ISSUER', OIDC_ISSUER);
    },
    get clientId() {
        return getRequiredValue('OIDC_CLIENT_ID', OIDC_CLIENT_ID);
    },
    get redirectUrl() {
        return getRequiredValue('OIDC_REDIRECT_URI', OIDC_REDIRECT_URI);
    },
    get postLogoutRedirectUrl() {
        return getRequiredValue('OIDC_POST_LOGOUT_REDIRECT_URI', OIDC_POST_LOGOUT_REDIRECT_URI);
    },
    scopes: OIDC_SCOPES,
};
